import { RecomendacaoModel } from '../../../projects/core/src/lib/core/model/RecomendacaoModel';
import { ResponseModel } from '../../../projects/core/src/lib/core/model/ResponseModel';
import { GraficoPage } from './grafico.page';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';

export class GraficoViewModel {

    recomendacaoModel = new RecomendacaoModel()
    context: GraficoPage

    setContext(context: GraficoPage) {
        this.context = context
    }

    getContext(): GraficoPage {
        return this.context
    }

    async getGraficoAtivo(idAtivo: Number) {
        let retorno = await this.recomendacaoModel.getGraficoAtivoPorId(idAtivo)
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().setGraficoAtivo(retorno.data)
            } else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {}
    }
}